<template>
  <form-field-input
    :label="label"
    v-model="filterValue"
    :help-text="helpText"
    @change="handleInput"
    type="number"
  ></form-field-input>
</template>

<script>
export default {
  name: "FilterLotSize",
  props: {
    label: {
      type: String,
      default: "Lot Size"
    },
    helpText: String,
    storeModule: {
      type: String,
      required: true
    },
    filterName: {
      type: String,
      required: true
    },
  },
  computed: {
    filterValue: {
      get() {
        return this.$store.state[this.storeModule].filters[this.filterName].lotSize;
      },
      set(value) {
        this.$store.commit(this.storeModule + "/setOneFilter", [
          this.filterName,
          "lotSize",
          value
        ]);
      }
    },
    text() {
      return (this.filterValue)
        ? `Lot Size: ${this.filterValue}`
        : null
    },
  },
  created() {
    this.handleInput();
  },
  methods: {
    handleInput() {
      this.$emit("change", this.text);
    },
  }
};
</script>
